module.exports = __webpack_public_path__ + "9fc74e333bd26d5f712716435234b714.png";